<template>
    <fieldset>
        <legend class="shop__fieldgroup-title">{{Strings['Shop.Product']}}</legend>
        <div class="shop__error-message-block" v-if="ErrorType === 'OverMaxAmount'">
            <v-runtime-template :template="Strings['Shop.Errors.OverMaxAmountPellets']" />
        </div>        
        <div class="shop__error-message-block" v-else-if="ErrorType === 'ZipCodeInvalid'">
            {{Strings['Shop.Errors.ZipCodeInvalid']}}
        </div>
        <div class="shop__error-message-block" v-else-if="ErrorType === 'Unexpected'">
            {{Strings['Shop.Errors.PricesCantBeCalculated']}}
        </div>
        <div class="shop__materials">
            <div class="shop__material shop__material--selected">
                <div class="shop__material-block-desc shop__material-block-desc--grid">
                    <div class="shop__material-icon"><img :src="material.iconUrl" width="100" /></div>
                    <div class="shop__material-name" v-html="migrolFormatText(material.name)"></div>
                    <div class="shop__material-description" v-html="material.description"></div>
                </div>
                <div class="shop__material-block-price">
                    <div class="shop__material-price-loading" v-show="PricesLoading">
                        <div class="shop__material-price-loading-ani-container">
                            <div class="shop__material-price-loading-ani"></div>
                        </div>
                        {{Strings['Shop.PriceCalculating']}}
                    </div>
                    <div class="shop__material-price" v-show="showPrice">
                        <div v-if="PricesAvailable">
                            <div class="shop__material-price-per-unit">{{UnitPrice|formatPrice}}<br/><span class="shop__material-price-unit">{{Strings['Shop.For100Kg']}}</span></div>
                            <div class="shop__material-price-total"><small>{{Strings['Shop.Total']}} {{TotalPrice|formatPrice}}</small><br/><span class="shop__material-total-tax">{{Strings['Shop.InclTax']}}</span></div>
                        </div>
                        <div v-if="!PricesAvailable" class="shop__material-price-unavailable">
                            {{Strings['Shop.ProductUnavailable']}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="shop__price-info" v-show="PricesAvailable">
            <v-runtime-template :template="PriceInfoText" />
        </div>
    </fieldset>
</template>

<script>
    import { mapState } from 'vuex';
    import { mapFilters } from '@/utils/vueFilters';
    import Transaction from '@/models/Transaction';
    import VRuntimeTemplate from "v-runtime-template";
    import { PriceRequestOutcomes } from '@/utils/constants';

    export default {
        props: {
            material: Object,
            showPrice: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'PricesLoading',
                'MaxAmountTotal',
                'DirectPriceActivated',
                'PriceCalculationOutcome'
            ]),
            UnitPrice() {
                return this.material.getUnitPrice(null);
            },
            TotalPrice() {
                return this.material.getTotalPrice(null);
            },
            CurrentTransaction() {
                return Transaction.query().with(['material','positions']).first();
            },
            PricesAvailable() {
                return this.UnitPrice != null && this.TotalPrice != null;
            },
            ErrorType() {
                if (this.DirectPriceActivated && this.CurrentTransaction.totalAmount > this.MaxAmountTotal)
                    return "OverMaxAmount";
                if (this.PriceCalculationOutcome != null && this.PriceCalculationOutcome == PriceRequestOutcomes.ZipCodeInvalid)
                    return "ZipCodeInvalid";
                if (this.PriceCalculationOutcome != null && this.PriceCalculationOutcome == PriceRequestOutcomes.Unexpected)
                    return "Unexpected";
                return null;
            }
        },
        methods: {
            ...mapFilters([
                'migrolFormatText'
            ])
        },
        components: {
            VRuntimeTemplate
        }
    };
</script>